/* Thistle Tavern — follow the browser appearance until the visitor changes it. */
(function () {
  'use strict';

  var key = 'tt-storefront-theme';
  var sourceKey = 'tt-storefront-theme-source';
  var root = document.documentElement;
  var systemQuery = null;
  try {
    if (window.matchMedia) systemQuery = window.matchMedia('(prefers-color-scheme: dark)');
  } catch (error) { /* Browser preference unavailable. */ }

  function browserTheme() {
    return systemQuery && systemQuery.matches ? 'dark' : 'light';
  }

  function followsSystem() {
    try {
      var saved = localStorage.getItem(key);
      return localStorage.getItem(sourceKey) === 'system' || (saved !== 'dark' && saved !== 'light');
    } catch (error) { return true; }
  }

  function storedOrSystemTheme() {
    if (followsSystem()) return browserTheme();
    try { return localStorage.getItem(key) === 'dark' ? 'dark' : 'light'; }
    catch (error) { return browserTheme(); }
  }

  function currentTheme() {
    return root.getAttribute('data-tt-theme') === 'dark' ? 'dark' : 'light';
  }

  function syncButtons() {
    var isDark = currentTheme() === 'dark';
    document.querySelectorAll('[data-tt-theme-toggle]').forEach(function (button) {
      var label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  }

  function applyTheme(theme, save, source) {
    var next = theme === 'dark' ? 'dark' : 'light';
    root.setAttribute('data-tt-theme', next);
    if (save) {
      try {
        localStorage.setItem(sourceKey, source === 'system' ? 'system' : 'manual');
        localStorage.setItem(key, next);
      } catch (error) { /* storage disabled */ }
    }
    syncButtons();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-tt-theme-toggle]');
    if (!button) return;
    applyTheme(currentTheme() === 'dark' ? 'light' : 'dark', true, 'manual');
  });

  /* Follow future browser/OS changes only until the visitor selects a mode. */
  function systemChanged() {
    if (followsSystem()) applyTheme(browserTheme(), true, 'system');
  }
  if (systemQuery) {
    if (systemQuery.addEventListener) systemQuery.addEventListener('change', systemChanged);
    else if (systemQuery.addListener) systemQuery.addListener(systemChanged);
  }

  /* Shopify can replace footer markup; another tab can change the preference. */
  document.addEventListener('shopify:section:load', syncButtons);
  window.addEventListener('storage', function (event) {
    if (event.key === key || event.key === sourceKey || event.key === null) {
      applyTheme(storedOrSystemTheme(), false);
    }
  });

  syncButtons();
}());
